import { TeamMember } from "@/models/team-member.model";
import { Team } from "@/models/team.model";
import { MutationTree } from "vuex";
import { TeamsState } from ".";
import store from "..";
import { namespaceRoles } from "../roles";
import { PaginationResponse } from "./../../models/pagination.model";
import { Role, RoleNames } from "./../../models/role.model";

export const TeamsMutationTypes = {
  SetTeams: "SET_TEAMS",
  CreateTeam: "CREATE_TEAM",
  SetTeam: "SET_TEAM",
  UpdateTeamForm: "UPDATE_TEAM_FORM",
  GetTeamMembers: "GET_TEAM_MEMBERS",
  AddTeamMember: "ADD_TEAM_MEMBER",
  RemoveTeamMember: "REMOVE_TEAM_MEMBER",
  ModifyTeamMember: "MODIFY_TEAM_MEMBER",
  SetCaptain: "SET_CAPTAIN"
};

export const mutations: MutationTree<TeamsState> = {
  [TeamsMutationTypes.SetTeams](state: TeamsState, payload: PaginationResponse<Team[]>) {
    state.teams = payload.data;
    state.paginationMeta = payload.meta;
  },
  [TeamsMutationTypes.CreateTeam](state: TeamsState, payload: Team[]) {
    state.teams = payload;
  },
  [TeamsMutationTypes.SetTeam](state: TeamsState, payload: Team) {
    state.team = payload;
  },
  [TeamsMutationTypes.UpdateTeamForm](state: TeamsState, changes: Team) {
    state.team = {
      ...state.team,
      ...changes
    };
  },
  [TeamsMutationTypes.GetTeamMembers](state: TeamsState, payload: TeamMember[]) {
    state.teamMembers = payload;
  },
  [TeamsMutationTypes.AddTeamMember](state: TeamsState, payload: TeamMember) {
    state.teamMembers = [...state.teamMembers, payload];
  },
  [TeamsMutationTypes.RemoveTeamMember](state: TeamsState, payload: number) {
    state.teamMembers = state.teamMembers.slice().filter(teamMember => teamMember.user_id !== payload);
  },
  [TeamsMutationTypes.ModifyTeamMember](state: TeamsState, payload: { userId: number; teamMember: TeamMember }) {
    state.teamMembers = state.teamMembers.map(member => (member.user_id === payload.userId ? payload.teamMember : member));
  },
  [TeamsMutationTypes.SetCaptain](state: TeamsState, payload: { userId: number }) {
    const roles: Role[] = store.getters[`${namespaceRoles}/getRoles`];
    const captainRole = roles.find(role => role.name === RoleNames.Captain);
    const memberRole = roles.find(role => role.name === RoleNames.Member);

    state.teamMembers = state.teamMembers.map(teamMember => {
      if (teamMember.user_id === payload.userId) {
        return {
          ...teamMember,
          role: captainRole
        };
      } else if (teamMember.role.name === captainRole.name) {
        return {
          ...teamMember,
          role: memberRole
        };
      } else {
        return teamMember;
      }
    });
  }
};
